import { createApp } from "vue";
import App from "./App.vue";
import Emitter from "tiny-emitter";
import router from "./router";
import BootstrapVue3 from "bootstrap-vue-3";
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from "vue3-scroll-spy";
import Maska from "maska";
import "sweetalert2/dist/sweetalert2.min.css";
import "@vueform/slider/themes/default.css";
import store from "./state/store";
import "../src/design/app.scss";
import "../src/assets/css/deepak.css";
import "../src/assets/css/custom.css";
import "../src/assets/css/ecu-portal.css";

import axios from "axios";
import base_domain from "./router/myvars";
import { installAuthInterceptors } from "./services/api";

// Production console sanitization: suppress sensitive logs in production builds
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

// Set global Axios base URL from environment / base_domain
axios.defaults.baseURL =
  base_domain || process.env.API_BASE_URL || "http://127.0.0.1:8000";

installAuthInterceptors(axios);

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$msalInstance = {};
app.config.globalProperties.$emitter = new Emitter();
app.use(store);
app.use(router);
app.use(require("vue-chartist"));
app.use(BootstrapVue3);
app.use(VueApexCharts);
app.use(vClickOutside);

app.use(registerScrollSpy);
app.use(Maska);
app.mount("#app");